
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36.987 6.829"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_34784","data-name":"Group 34784","transform":"translate(-642 -191.585)"}},[_c('g',{attrs:{"id":"Group_34780","data-name":"Group 34780","transform":"translate(639.998 187.75)"}},[_c('g',{attrs:{"id":"Group_34778","data-name":"Group 34778","transform":"translate(12 5)"}},[_c('g',{attrs:{"id":"Group_34648","data-name":"Group 34648","fill":"none","stroke":"#dfe4ef","stroke-linecap":"round","stroke-width":"2"}},[_c('path',{attrs:{"id":"Path_21163","data-name":"Path 21163","d":"M0 32.955V0","transform":"rotate(90 11.598 13.848)"}}),_c('path',{attrs:{"id":"Path_21294","data-name":"Path 21294","d":"M36.37 118.606l-1.951-2 1.951-2","transform":"translate(-43.417 -114.355)","stroke-linejoin":"round"}}),_c('path',{attrs:{"id":"Path_21295","data-name":"Path 21295","d":"M36.37 118.606l-1.951-2 1.951-2","transform":"rotate(180 30.204 59.428)","stroke-linejoin":"round"}})])])])])])
          )
        }
      }
    